import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Fade } from "react-reveal";


export default function PaymentModel(props) {
    let ele = document.getElementsByClassName("App");

    useEffect(() => {
        if (props?.show) {
            ele[0].classList.add("mystyle");
        } else {
            ele[0].classList.remove("mystyle");
        }
    }, [props?.show]);

 /**
     * Used for render the url  of uniramp in iFrame
     */
    return (
        <Modal
            {...props}

            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="modal_iframe modal_iframeuniramp"
        >

            <Modal.Body>

                <Fade>
                    <a
                        href="javascript:void(0)"
                        className="close-btn"
                        onClick={props.onHide}
                    >
                        <span className="">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 51 50"
                                fill="none"
                            >
                                <path
                                    d="M40.0417 10.2084C31.9167 2.08337 18.5834 2.08337 10.4584 10.2084C2.33337 18.3334 2.33337 31.6667 10.4584 39.7917C18.5834 47.9167 31.7084 47.9167 39.8334 39.7917C47.9584 31.6667 48.1667 18.3334 40.0417 10.2084ZM31.0834 33.75L25.25 27.9167L19.4167 33.75L16.5 30.8334L22.3334 25L16.5 19.1667L19.4167 16.25L25.25 22.0834L31.0834 16.25L34 19.1667L28.1667 25L34 30.8334L31.0834 33.75Z"
                                    fill="black"
                                />
                            </svg>
                        </span>
                    </a>
                    <iframe id="iFrameId" ref={props?.iframeRef} src={props?.paymentUrl} title="Payment">
                    </iframe>
                </Fade>
            </Modal.Body>
        </Modal>
    );
}
